import { useState } from "react";
import { Copy, Check, Mail, ArrowUpRight, Instagram } from "lucide-react";
import { toast } from "sonner";
import { PageHero } from "../components/site/PageHero";
import { FadeUp, Eyebrow } from "../components/site/Motion";
import { EMAIL, INSTAGRAM_URL } from "../data/content";
import { useLang } from "../i18n/LangContext";

export default function Contatti() {
  const { t } = useLang();
  const c = t.contatti;
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      toast.success(c.toastOk);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error(c.toastErr);
    }
  };

  return (
    <main data-testid="contatti-page">
      <PageHero
        key={c.lines[0]}
        testId="contatti-hero"
        eyebrow={c.eyebrow}
        lines={c.lines}
        intro={c.intro}
      />
      <section className="mx-auto max-w-7xl px-5 pb-24 sm:px-8 lg:pb-32">
        <FadeUp className="border-t border-[#D6CEBF] pt-14">
          <Eyebrow>{c.email}</Eyebrow>
          <a href={`mailto:${EMAIL}`} data-testid="contatti-email-link" className="block break-all font-serif text-4xl text-[#1C1917] transition-colors duration-300 hover:text-[#C85A32] sm:text-6xl lg:text-7xl">
            {EMAIL}
          </a>
          <div className="mt-10 flex flex-wrap gap-4">
            <a href={`mailto:${EMAIL}`} data-testid="contatti-write-btn" className="inline-flex items-center gap-3 rounded-full bg-[#1C1917] px-7 py-4 text-sm font-medium text-[#FBF9F5] transition-colors duration-300 hover:bg-[#C85A32]">
              <Mail size={16} /> {c.write}
            </a>
            <button onClick={copy} data-testid="contatti-copy-btn" className="inline-flex items-center gap-3 rounded-full border border-[#D6CEBF] px-7 py-4 text-sm font-medium text-[#1C1917] transition-colors duration-300 hover:border-[#1C1917]">
              {copied ? <Check size={16} className="text-[#3B5E4C]" /> : <Copy size={16} />} {copied ? c.copied : c.copy}
            </button>
          </div>
        </FadeUp>
        <FadeUp delay={0.1} className="mt-20 grid gap-px border border-[#D6CEBF] bg-[#D6CEBF] sm:grid-cols-3">
          <div className="bg-[#FBF9F5] p-8 sm:p-10">
            <Eyebrow>{c.social}</Eyebrow>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="contatti-instagram-link" className="group inline-flex items-center gap-3 font-serif text-3xl text-[#1C1917]">
              <Instagram className="h-6 w-6" /> Instagram <ArrowUpRight className="transition-transform duration-300 group-hover:rotate-45" />
            </a>
          </div>
          <div className="bg-[#FBF9F5] p-8 sm:p-10">
            <Eyebrow>{c.blog}</Eyebrow>
            <address data-testid="contatti-sede" className="not-italic">
              <p className="font-serif text-3xl leading-tight text-[#1C1917]">Via Canero 14</p>
              <p className="mt-1 font-serif text-2xl text-[#1C1917]">24010 Ponteranica (Bergamo)</p>
              <p className="mt-1 text-stone-600">{c.country} · C.F. 95259900165</p>
            </address>
          </div>
          <div className="bg-[#FBF9F5] p-8 sm:p-10">
            <Eyebrow>{c.assoc}</Eyebrow>
            <p className="font-serif text-3xl text-[#1C1917]">Lunghe Frequenze APS</p>
            <p className="mt-2 text-stone-600">{t.tagline} · {t.runts}</p>
          </div>
        </FadeUp>
      </section>
    </main>
  );
}
